import React from "react"
import { Link } from "react-router-dom"

import WidgetHeaderButton from "../../common/WidgetHeaderButton"
import RefreshButton from "../../common/RefreshButton"

const KnowledgeListWidget = ({
    isFilterEnabled,
    isAddingEnabled,
    onFilterSelect,
    isFetching,
    invalidate,
    pagingRequest,
    ...rest
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-article" />Feed&nbsp;
            <div className="pull-right edge-pull-right-fix">
                <RefreshButton onClick={invalidate(pagingRequest)} />
                {isAddingEnabled && (
                    <Link to="/knowledge/add">
                        <WidgetHeaderButton>
                            <span
                                className="icon icon-add-feed-button"
                                style={{ marginTop: "0px" }}
                            />
                            <span className="button-inner-alignment">
                                &nbsp;Add
                            </span>
                        </WidgetHeaderButton>
                    </Link>
                )}
                {isFilterEnabled && (
                    <WidgetHeaderButton onClick={onFilterSelect}>
                        Filter
                    </WidgetHeaderButton>
                )}
            </div>
        </h3>
        <rest.knowledgeListContainerComponent />
    </div>
)

export default KnowledgeListWidget
